var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioOn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.765,
    height: 14.609,
    viewBox: "0 0 10.765 14.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15633"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15632"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13746",
    d: "M5.383 9.227a2.3 2.3 0 002.3-2.307l.008-4.613a2.307 2.307 0 10-4.613 0V6.92a2.308 2.308 0 002.305 2.307z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13747",
    d: "M9.457 6.92a4.078 4.078 0 01-8.15 0H0a5.364 5.364 0 004.613 5.167v2.522h1.538v-2.522a5.364 5.364 0 004.616-5.167z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOn);
export default __webpack_public_path__ + "static/media/audio-on.cf057f04dbe2c60970f0f3afbffe3014.svg";
export { ForwardRef as ReactComponent };